"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Overview card types:
 *
 * MAIN_CARD - card for root entity
 * GROUP_CARD - card for root entity's related category's grouped and applied some aggregation function to
 * SINGLE_ENTITY_CARD - card for a single entity, related to the root entity.
 * Can be created first time from overview navigation
 * CUSTOM_CARD - card with custom navigation
 *
 * @readonly
 * @enum {number}
 */
var OverviewCardType;
(function (OverviewCardType) {
    OverviewCardType[OverviewCardType["MAIN_CARD"] = 1] = "MAIN_CARD";
    OverviewCardType[OverviewCardType["GROUP_CARD"] = 2] = "GROUP_CARD";
    OverviewCardType[OverviewCardType["SINGLE_ENTITY_CARD"] = 3] = "SINGLE_ENTITY_CARD";
    OverviewCardType[OverviewCardType["CUSTOM_CARD"] = 4] = "CUSTOM_CARD";
})(OverviewCardType = exports.OverviewCardType || (exports.OverviewCardType = {}));
//# sourceMappingURL=overview-card-type.js.map